/**
 * Convierte una imagen base64 a una URL de datos que puede ser usada en src de img
 * @param {string} base64String - String base64 de la imagen
 * @returns {string} - URL de datos para usar en src
 */
export const base64ToImageUrl = (base64String) => {
  if (!base64String) return null;
  
  // Si ya incluye el prefijo data:image, devolverlo tal como está
  if (base64String.startsWith('data:image')) {
    return base64String;
  }
  
  // Asumir que es PNG por defecto, pero podrías detectar el tipo
  return `data:image/png;base64,${base64String}`;
};

/**
 * Verifica si una cadena es una imagen base64 válida
 * @param {string} str - String a verificar
 * @returns {boolean} - true si es base64 válido
 */
export const isBase64Image = (str) => {
  if (!str || typeof str !== 'string') return false;
  
  // Verificar si ya tiene el prefijo data:image
  if (str.startsWith('data:image')) return true;
  
  // Verificar si parece ser base64 (caracteres alfanuméricos + / + =)
  const base64Pattern = /^[A-Za-z0-9+/]*={0,2}$/;
  return base64Pattern.test(str) && str.length > 50; // Longitud mínima para una imagen
};
